/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useContext } from "react";
import { AppContext } from 'Context/AppContext';
import {
  ATTRIBUTE,
  CHOICES,
  COUNT,
  DATA_CONFIGURATION,
  DEFAULT_VALUE,
  ENTER,
  ENTER_CHOICE,
  FIELD_CLASS,
  ITEM_IMAGE,
  LIST,
  MANAGE,
  MAX,
  MIN,
  NO_IMAGE_AVAILABLE,
  PREDICTIVE_SORT,
  QUANTITY,
  SELECTION_TYPE,
  SELECT_CLASS,
  SYNC,
  VIEW_ON_LISTS,
  QUANTITY_INFO_TEXT,
  QUANTITY_INFO_TITLE,
  COUNT_INFO_TEXT,
  COUNT_INFO_TITLE,
} from "../ISRConstants";
import { DeleteIcon, ExternalLinkIcon, ImageIcon } from "assests/GmsIcons";
import { Refresh } from "Components/DesignSystem/Iconography/Icons";
import { Data, TChoice, TField, TFieldDataConfiguration, TSubmodel, TConnector, TFieldClass, TProductCategory, TListItem, TUpsertISRProjectDataModelsInput, TIndexState, } from "../Pages/DefineModel/model";
import { getAllProjectClass, getAttributeValues,} from "../Pages/DefineModel/ModelServices/ModalServices";
import Card from 'Components/DesignSystem/Card/Card';
import TextField from 'Components/DesignSystem/TextField/TextField';
import Dropdown from 'Components/DesignSystem/Dropdown/Dropdown';
import Toggle from 'Components/DesignSystem/Toggle/Toggle';
import Button from 'Components/DesignSystem/Button/Button';
import Typography from 'Components/DesignSystem/Typography/Typography';
import FieldTitle from 'Components/DesignSystem/FieldTitle/FieldTitle';
import Dialog from 'Components/DesignSystem/Dialog/Dialog';
import DsTooltip from 'Components/DesignSystem/Tooltip/Tooltip';
import InfoTooltip from 'Components/DesignSystem/Tooltip/InfoTooltip';
import FieldClassSelector from './FieldClassSelector';
import { useISRContext } from "../Hooks/useISRContext";
import ConfigurationFilterComponent from "./ConfigurationFilterComponent";
import ConfigurationFilter from "./ConfigurationFilter";
import ItemImportDropdown from "../Pages/DefineModel/Components/ItemImportDropdown";
import { useNavigate, useLocation } from "react-router";
import { getListItem } from "Pages/GMS/List/Services/ListServices";
import { toast } from 'Components/DesignSystem/Toast/useToast';

type TInputField = {
  id: number;
  value: string;
  choices: string;
};

type TMultiChoiceProps = {
  id: string;
  categoryTypeList: string[];
  categoryData: Data[];
  attributeData: Data[];
  listData: any[];
  projectId?: string;
  selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
  updateFieldDataConfiguration: Function;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  indexInfo: TIndexState;

};

const MultiChoiceConfigurations = ({ id, listData, categoryData, attributeData, selectedItem, updateFieldDataConfiguration, projectId, userProjectDataModels, indexInfo }: TMultiChoiceProps) => {
  const [fieldDataConfiguration, setFieldDataConfiguration] = useState<TFieldDataConfiguration>({});
  const location = useLocation();
  const [inputFields, setInputFields] = useState<TInputField[]>([{ id: 1, value: "", choices: "" },]);
  const isrContext = useISRContext();
  const itemImportDropDownRef = useRef<any>(null)
  const [showImage, setShowImage] = useState<boolean>(false);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<string>(ATTRIBUTE);
  const [selectedId, setSelectedId] = useState<string | undefined>("");

  const isGuide = Boolean(location.pathname.includes('/guide/'));

  const { enableConfigure } = useContext(AppContext);

  const isConfigureDisabled = isGuide && !enableConfigure;

  const [countRangeError, setCountRangeError] = useState<string>('');
  const [quantityRangeError, setQuantityRangeError] = useState<string>('');

  // Define state for current page
  const [currentPage, setCurrentPage] = useState(1);
  const [visiblePages, setVisiblePages] = useState<number[]>([]);

  // Define state for loaded data
  const [loadedData, setLoadedData] = useState<TChoice[] | TListItem[]>([]);

  const navigate = useNavigate();
  const listsOptions = listData?.map((x) => {
    return { label: x?.name, value: x?.id };
  });
  const attributeOptions = attributeData?.map((x: any) => {
    return { label: x?.name, value: x?.id };
  });

  useEffect(() => {
    itemImportDropDownRef?.current?.clearSearchTerm();
    setSelectedId("");
    setFieldDataConfiguration({});
    const existingValue =
      selectedItem &&
      "dataConfiguration" in selectedItem &&
      selectedItem?.dataConfiguration
        ? selectedItem.dataConfiguration
        : {};
    setFieldDataConfiguration(existingValue);
    setSelectedFilter(existingValue?.propType ?? ATTRIBUTE);
    setSelectedId(existingValue?.id);
    const minC = existingValue?.minCount ?? 0;
    const maxC = existingValue?.maxCount ?? 0;
    setCountRangeError(minC > maxC ? 'Minimum value cannot be greater than the maximum.' : '');
    const minQ = existingValue?.minQuantity ?? 0;
    const maxQ = existingValue?.maxQuantity ?? 0;
    setQuantityRangeError(minQ > maxQ ? 'Minimum value cannot be greater than the maximum.' : '');
  }, [selectedItem]);

  useEffect(() => {
    if(fieldDataConfiguration?.id){
      setSelectedId(fieldDataConfiguration?.id);
      if (
        !fieldDataConfiguration?.choices ||
        fieldDataConfiguration?.choices.length === 0
      ) {
        fieldDataConfiguration?.propType === LIST
          ? fetchListValues(fieldDataConfiguration?.id)
          : fetchAttributeValues(fieldDataConfiguration?.id);
      }
    }
  }, [fieldDataConfiguration?.id]);

  useEffect(() => {
    if (!countRangeError && !quantityRangeError) {
      updateFieldDataConfiguration(fieldDataConfiguration);
    }
  }, [fieldDataConfiguration, countRangeError, quantityRangeError]);

  useEffect(() => {
    fetchAllClasses();
  }, []);

  useEffect(() => {
    setVisiblePagesHandler();
    console.log("ASSD", selectedFilter)
  }, [selectedFilter, fieldDataConfiguration?.choices]);

  const customOptions: any = [];
  // const [selectedCustom, setSelectedCustom] = useState<string>("");

  const handleDeleteField = (attributeValues: any, index: number) => {
    console.log(attributeValues);
    // av_id
    const updatedChoices = [...(fieldDataConfiguration?.choices || [])].filter(obj => obj.av_id !== attributeValues.av_id);
    // updatedChoices.splice(index, 1);
    setFieldDataConfiguration((prevConfig) => ({
      ...prevConfig,
      choices: updatedChoices,
    }));
  };

  const handleInputChange = (
    index: number,
    inputValue: string,
    propertyName: string
  ) => {
    const updatedInputFields = [...inputFields];
    updatedInputFields[index] = {
      ...updatedInputFields[index],
      [propertyName]: inputValue,
    };
    setInputFields(updatedInputFields);
  };

  const fetchAttributeValues = async (attributeId: string) => {
    try {
      const responseData = await getAttributeValues(attributeId);
      if (responseData?.done) {
        const newChoices = responseData?.data?.map(
          (c: any) => {
            return {
              ...c,
              display_value: c?.av_value,
            };
          }
        );
        updateChoices(attributeId, ATTRIBUTE, newChoices);
      } else {
        updateChoices(attributeId, ATTRIBUTE, []);
      }
    } catch (error) {
      updateChoices(attributeId, ATTRIBUTE, []);
      console.log(error, "Error");
    }
  };

  const fetchListValues = async (listId: string) => {
    try {
      const responseData = await getListItem(listId);
      if (!responseData?.errorfound) {
        const newChoices = responseData?.data?.data?.items?.filter(
          (x: TListItem) => x.visibility
        )?.map(
          (c: TListItem) => {
            return {
              av_id: c?.title,
              av_value: c?.title,
              display_value: c?.display_value,
              product_image: c?.image,
              visibility: c?.visibility,
              helpText: c?.helpText,
              math_value: c?.math_value,
              tag: c?.tag,
            };
          }
        );
        updateChoices(listId, LIST, newChoices);
      } else {
        updateChoices(listId, LIST,  []);
      }
    } catch (error) {
      updateChoices(listId, LIST,  []);
      console.log(error, "Error");
    }
  };

  const updateChoices = (id: string, type: string, newChoices: TChoice[] | undefined) => {
    const updatedFieldDataConfiguration = { ...fieldDataConfiguration };
    updatedFieldDataConfiguration.id = id;
    updatedFieldDataConfiguration.propType = type;
    updatedFieldDataConfiguration.choices = Array.isArray(newChoices)
      ? newChoices
      : [];
    setFieldDataConfiguration(updatedFieldDataConfiguration);
  };

  const handleSelectTypeChange = (value: string | number) => {
    const updatedFieldDataConfiguration = { ...fieldDataConfiguration };
    updatedFieldDataConfiguration.selectType = !!value ? String(value) : undefined;
    setFieldDataConfiguration(updatedFieldDataConfiguration);
  };

  const handleDefaultTypeChange = (value: string | number) => {
    const updatedFieldDataConfiguration = { ...fieldDataConfiguration };
    updatedFieldDataConfiguration.defaultValue = !!value ? String(value) : undefined;
    setFieldDataConfiguration(updatedFieldDataConfiguration);
  };

  const handlePredictiveSortChange = (value: boolean) => {
    setFieldDataConfiguration((prevConfig) => ({
      ...prevConfig,
      predictiveSort: value,
    }));
  };

  const handleClassChange = (selectedValue: string) => {
    const selectedObject = isrContext?.fieldClasses?.find(
      (item: TFieldClass) => item.name === selectedValue
    );
    setFieldDataConfiguration((prevConfig) => ({
      ...prevConfig,
      class: selectedObject,
    }));
  };

  const fetchAllClasses = async () => {
    try {
      const responseData = await getAllProjectClass(projectId ?? "");
      if (responseData?.done) {
        isrContext?.setFieldClasses(responseData?.data?.fieldClasses ?? []);
        isrContext?.setModelClasses(responseData?.data?.modelClasses ?? []);
      } else {
        //toast.error(responseData?.message);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  // Assuming you have the following constants
  const ITEMS_PER_PAGE = 10;
  const VISIBLE_PAGES = 10;

  // Function to handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const setVisiblePagesHandler = () => {
    if (fieldDataConfiguration?.choices) {
      setLoadedData(fieldDataConfiguration.choices);
      setVisiblePages(
        getVisiblePageRange(
          1,
          Math.ceil(fieldDataConfiguration?.choices.length / ITEMS_PER_PAGE)
        )
      );
    }
  };

  // Calculate the index range for the current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  // Function to get the visible page range
  const getVisiblePageRange = (currentPage: number, totalPages: number) => {
    const middle = Math.floor(VISIBLE_PAGES / 2);
    let start = currentPage - middle;
    let end = currentPage + middle;

    if (start <= 0) {
      start = 1;
      end = Math.min(totalPages, VISIBLE_PAGES);
    }

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - VISIBLE_PAGES + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const handleMinCount = (value: number) => {
    const clampedValue = Math.max(0, value);
    const currentMaxCount = fieldDataConfiguration?.maxCount ?? 0;
    if (clampedValue > currentMaxCount) {
      setCountRangeError('Minimum value cannot be greater than the maximum.');
    } else {
      setCountRangeError('');
    }
    setFieldDataConfiguration((prevConfig) => {
      if (!prevConfig) return prevConfig;
      return { ...prevConfig, minCount: clampedValue };
    });
  };

  const handleMaxCount = (value: number) => {
    const clampedValue = Math.max(0, value);
    const currentMinCount = fieldDataConfiguration?.minCount ?? 0;
    if (clampedValue < currentMinCount) {
      setCountRangeError('Minimum value cannot be greater than the maximum.');
    } else {
      setCountRangeError('');
    }
    setFieldDataConfiguration((prevConfig) => {
      if (!prevConfig) return prevConfig;
      return { ...prevConfig, maxCount: clampedValue };
    });
  };

  const handleMinQuantity = (value: number) => {
    const clampedValue = Math.max(0, value);
    const currentMaxQuantity = fieldDataConfiguration?.maxQuantity ?? 0;
    if (clampedValue > currentMaxQuantity) {
      setQuantityRangeError('Minimum value cannot be greater than the maximum.');
    } else {
      setQuantityRangeError('');
    }
    setFieldDataConfiguration((prevConfig) => {
      if (!prevConfig) return prevConfig;
      return { ...prevConfig, minQuantity: clampedValue };
    });
  };

  const handleMaxQuantity = (value: number) => {
    const clampedValue = Math.max(0, value);
    const currentMinQuantity = fieldDataConfiguration?.minQuantity ?? 0;
    if (clampedValue < currentMinQuantity) {
      setQuantityRangeError('Minimum value cannot be greater than the maximum.');
    } else {
      setQuantityRangeError('');
    }
    setFieldDataConfiguration((prevConfig) => {
      if (!prevConfig) return prevConfig;
      return { ...prevConfig, maxQuantity: clampedValue };
    });
  };

  /* The sync glyph is the DS Refresh at 16 (icon-slot norm) — GmsIcons'
     ReloadIcon baked the retired #0747A6 stroke, invisible on a dark ground. */
  const syncButton = (testid: string, onClick: () => void) => (
    <Button
      id={testid}
      data-testid={testid}
      variant="tertiary"
      size="sm"
      icon={<Refresh size={16} aria-hidden="true" />}
      showIcon
      onClick={onClick}
    >
      {SYNC}
    </Button>
  );

  return (
    <Card id={id} data-testid={id}>
      <div className="tw-flex tw-justify-between tw-items-center ">
        <Typography variant="title-header" as="h3" className="tw-text-ink">
          {DATA_CONFIGURATION}
        </Typography>
        <div className="tw-flex tw-flex-wrap tw-items-center">
          <ConfigurationFilter
            id={`${id}-filter`}
            labels={[ATTRIBUTE, LIST]}
            selectedFilter={selectedFilter ?? ""}
            setSelectedFilter={setSelectedFilter}
          />
        </div>
      </div>
      <div>
        <div className="tw-w-full tw-h-9 tw-mb-2 tw-left-0">
          {selectedFilter.toLocaleLowerCase() === "custom" && (
            <div className="tw-flex tw-justify-between">
              <div className="tw-w-[30%]">
                <ItemImportDropdown
                  id={`${id}-class-dropdown`}
                  onChange={(e: string) => {
                    setSelectedId(e);
                    fetchListValues(e);
                  }}
                  value={""}
                  options={customOptions}
                  name={`Select ${selectedFilter}`}
                  disabled={true}
                  isSearchable
                />
              </div>
              {syncButton('components-multichoiceconfigurationnew-button-1', () => {})}
            </div>
          )}
          {selectedFilter.toLocaleLowerCase() === ATTRIBUTE && (
            <div className="tw-flex tw-justify-between">
              <div className="tw-w-[30%]">
                <ItemImportDropdown
                  id={`${id}-attribute-dropdown`}
                  onChange={(e: string) => {
                    setSelectedId(e);
                    fetchAttributeValues(e);
                  }}
                  value={selectedId ?? ""}
                  options={attributeOptions}
                  name={`Select ${selectedFilter}`}
                  disabled={false}
                  isSearchable
                />
              </div>
              {syncButton('components-multichoiceconfigurationnew-button-2', () => {
                fetchAttributeValues(fieldDataConfiguration?.id ?? "");
              })}
            </div>
          )}
          {selectedFilter.toLocaleLowerCase() === LIST && (
            <div className="tw-flex tw-justify-between">
              <div className="tw-w-[30%]">
                <ItemImportDropdown
                  id={`${id}-list-dropdown`}
                  onChange={(e: string) => {
                    setSelectedId(e);
                    fetchListValues(e);
                  }}
                  value={selectedId ?? ""}
                  options={listsOptions}
                  name={`Select ${selectedFilter}`}
                  disabled={false}
                  isSearchable
                />
              </div>
              {selectedId && fieldDataConfiguration?.propType?.toLowerCase() == LIST && (
                <Button
                  id="components-multichoiceconfigurationnew-button-3"
                  data-testid="components-multichoiceconfigurationnew-button-3"
                  variant="tertiary"
                  size="sm"
                  icon={<ExternalLinkIcon />}
                  showIcon
                  className="tw-ml-[40%]"
                  onClick={() => { navigate(`/gms/lists/edit/${selectedId}`); }}
                >
                  {VIEW_ON_LISTS}
                </Button>
              )}
              {syncButton('components-multichoiceconfigurationnew-button-4', () => {
                fetchListValues(fieldDataConfiguration?.id ?? "");
              })}
            </div>
          )}
        </div>
      </div>

      {selectedFilter.toLowerCase() === ATTRIBUTE && fieldDataConfiguration?.propType?.toLowerCase()  == ATTRIBUTE && (
        <div>
          {fieldDataConfiguration?.choices &&
          fieldDataConfiguration?.choices.length !== 0 ? (
            <div className="tw-flex ">
              <div className="tw-label-header tw-w-[41%]">
                <FieldTitle label={CHOICES} />
              </div>
            </div>
          ) : null}

          {fieldDataConfiguration?.choices &&
            fieldDataConfiguration?.choices.length !== 0 &&
            fieldDataConfiguration?.choices
              ?.slice(startIndex, endIndex)
              ?.map((attributeValues, index) => (
                <div
                  key={index}
                  className="tw-flex tw-items-center tw-w-full tw-gap-2 tw-mb-2"
                >
                  <div className="tw-w-[40%] ">
                    {/* One testid on every row — a known duplicate. Templated from the
                        row's stable value so a spec can address a single choice. The
                        static one is kept on the FIRST row so existing specs still
                        resolve. */}
                    <TextField
                      data-testid={index === 0
                        ? 'components-multichoiceconfigurationnew-input-5'
                        : `${id}-choice-${index}`}
                      label=""
                      aria-label={CHOICES}
                      value={String(attributeValues?.value ? attributeValues?.value : attributeValues?.av_value ?? '')}
                      onChange={(value) => handleInputChange(index, value, "choices")}
                      placeholder={ENTER_CHOICE}
                      className="tw-w-full"
                    />
                  </div>
                  <div className="tw-w-auto tw-ms-1 ">
                    <Button
                      aria-label={`Delete ${attributeValues?.value ?? attributeValues?.av_value ?? 'choice'}`}
                      data-testid={index === 0
                        ? 'components-multichoiceconfigurationnew-button-6'
                        : `${id}-choice-delete-${index}`}
                      variant="subtle"
                      size="sm"
                      icon={<DeleteIcon />}
                      showIcon
                      onClick={() => handleDeleteField(attributeValues, index)}
                    >
                      {""}
                    </Button>
                  </div>
                </div>
              ))}
        </div>
      )}

      {selectedFilter.toLowerCase() === LIST && fieldDataConfiguration?.propType?.toLowerCase()  === LIST && (
        <div className="tw-w-full">
          {fieldDataConfiguration?.choices &&
            fieldDataConfiguration?.choices.length !== 0 &&
            fieldDataConfiguration?.choices
              ?.slice(startIndex, endIndex)
              ?.map((item, index) => (
                /* Was a `<tr>` with no table anywhere above it — invalid markup that
                   the browser hoists out of place. It is a row of a list, not of a
                   table, so it is a div. */
                <div
                  key={index}
                  className={`tw-h-12 ${
                    index % 2 === 0 ? "tw-bg-surface" : "tw-bg-surface-sunken"
                  } tw-pl-4 tw-pr-4 tw-border tw-border-edge`}
                >
                  {/* No ground or border of its own any more: the OUTER row div
                      already paints the tokened zebra (`surface`/`surface-sunken` +
                      `edge`), and this inner `tw-bg-white`/`tw-bg-gray-100` copy of
                      the same zebra painted a light-only slab over it — the white
                      rows in the dark-mode screenshot. */}
                  <div
                    className={`tw-h-12 tw-pl-4 tw-pr-4 tw-w-[720px] tw-flex tw-items-center tw-justify-center`}
                  >
                    <div
                      key={item?.av_id + index}
                      className="tw-flex tw-items-center tw-w-full tw-gap-2 tw-mb-2"
                    >
                      <div aria-label="Image" role="button" data-testid="components-multichoiceconfigurationnew-div-1"
                        onClick={() => {
                          setShowImage(true);
                          setImageUrl(item?.product_image);
                        }}
                      >
                        <ImageIcon />
                      </div>
                      <span className="tw-flex-1 tw-relative tw-text-ink focus:tw-outline-none">
                        {item?.display_value ?? item?.av_value}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
        </div>
      )}

      {fieldDataConfiguration?.propType === selectedFilter ? fieldDataConfiguration?.choices &&
            fieldDataConfiguration?.choices.length !== 0 &&
            loadedData &&
            loadedData.length > ITEMS_PER_PAGE && (
              <div className="tw-flex tw-justify-center tw-mt-4">
                {currentPage > 1 && (
                  <Button
                    data-testid="components-multichoiceconfigurationnew-button-7"
                    variant="tertiary"
                    size="sm"
                    onClick={() => {
                      handlePageChange(currentPage - 1);
                      setVisiblePages(
                        getVisiblePageRange(
                          currentPage - 1,
                          Math.ceil(loadedData.length / ITEMS_PER_PAGE)
                        )
                      );
                    }}
                  >
                    {"< Previous"}
                  </Button>
                )}
                {visiblePages.map((page) => (
                  /* The page buttons all shared ONE testid. The static one stays on
                     the first so existing specs resolve; the rest are addressable by
                     page number. Kept as Buttons rather than DS Pagination because
                     `getVisiblePageRange` is this component's own windowing logic and
                     swapping it would change behaviour, not markup. */
                  <Button
                    data-testid={page === visiblePages[0]
                      ? 'components-multichoiceconfigurationnew-button-8'
                      : `${id}-page-${page}`}
                    variant="tertiary"
                    size="sm"
                    key={page}
                    onClick={() => handlePageChange(page)}
                  >
                    {String(page)}
                  </Button>
                ))}
                {currentPage <
                  Math.ceil(loadedData.length / ITEMS_PER_PAGE) && (
                  <Button
                    data-testid="components-multichoiceconfigurationnew-button-9"
                    variant="tertiary"
                    size="sm"
                    onClick={() => {
                      handlePageChange(currentPage + 1);
                      setVisiblePages(
                        getVisiblePageRange(
                          currentPage + 1,
                          Math.ceil(loadedData.length / ITEMS_PER_PAGE)
                        )
                      );
                    }}
                  >
                    {"Next >"}
                  </Button>
                )}
              </div>
            ):null}

      {fieldDataConfiguration?.choices &&
        fieldDataConfiguration?.choices.length === 0 && (
          <div className="tw-w-[752px] tw-h-12 tw-bg-surface-sunken tw-rounded-ctl tw-border tw-border-edge tw-flex tw-items-center tw-justify-center">
            <Typography variant="body-primary" className="tw-text-ink-secondary">
              Select {selectedFilter} to load attribute values
            </Typography>
          </div>
        )}

      <div>
        <div className="tw-flex tw-items-start tw-gap-4 tw-mt-3">
          <Dropdown
            id={`${id}-selection-type`}
            data-testid={`${id}-selection-type`}
            label={SELECTION_TYPE}
            placeholder="Select"
            options={[
              { value: '', label: 'Select' },
              ...['Single-select', 'Multi-select'].map((item) => ({ value: item, label: item })),
            ]}
            value={fieldDataConfiguration?.selectType ?? ''}
            onChange={handleSelectTypeChange}
            usePortal
            className="tw-w-[20%]"
          />
          <Dropdown
            id={`${id}-default-value`}
            data-testid={`${id}-default-value`}
            label={DEFAULT_VALUE}
            placeholder="Select Choice"
            options={[
              { value: '', label: 'Select Choice' },
              ...((fieldDataConfiguration?.choices ?? []).map((item) => ({
                value: (item?.value ? item?.value : item?.av_value) ?? '',
                label: item?.display_value ?? item?.value ?? item?.av_value ?? '',
              }))),
            ]}
            value={fieldDataConfiguration.defaultValue ?? ''}
            onChange={handleDefaultTypeChange}
            usePortal
            className="tw-w-[40%]"
          />
          <div className="tw-w-[20%]">
            {/* `disabled` on the Tooltip rather than two near-identical arms. */}
            <DsTooltip content="Available with Configure" disabled={!isConfigureDisabled} placement="top">
              <span>
                <Toggle
                  id={`${id}-predictive-sort-toggle`}
                  data-testid={`${id}-predictive-sort-toggle`}
                  label={PREDICTIVE_SORT}
                  labelPlacement="top"
                  checked={fieldDataConfiguration?.predictiveSort ?? false}
                  onChange={handlePredictiveSortChange}
                  disabled={isConfigureDisabled}
                />
              </span>
            </DsTooltip>
          </div>
        </div>
      </div>
      <ConfigurationFilterComponent
        id={`${id}-config-filter`}
        fieldDataConfiguration={fieldDataConfiguration}
        setFieldDataConfiguration={setFieldDataConfiguration}
        userProjectDataModels={userProjectDataModels}
        indexInfo={indexInfo}
      />

      <FieldClassSelector
        baseId={id}
        value={fieldDataConfiguration?.class?.name ?? ''}
        onChange={handleClassChange}
        disabled={isConfigureDisabled}
        projectId={projectId}
      />

      {/* Count / Quantity — the same shape twice, written once. */}
      <div className="tw-flex tw-gap-x-6 tw-mt-4">
        {[
          {
            key: 'count',
            title: COUNT,
            infoTitle: COUNT_INFO_TITLE,
            infoText: COUNT_INFO_TEXT,
            min: fieldDataConfiguration?.minCount ?? 0,
            max: fieldDataConfiguration?.maxCount ?? 0,
            onMin: handleMinCount,
            onMax: handleMaxCount,
            error: countRangeError,
            minTestId: 'components-multichoiceconfigurationnew-input-16',
            maxTestId: 'components-multichoiceconfigurationnew-input-17',
          },
          {
            key: 'quantity',
            title: QUANTITY,
            infoTitle: QUANTITY_INFO_TITLE,
            infoText: QUANTITY_INFO_TEXT,
            min: fieldDataConfiguration?.minQuantity ?? 0,
            max: fieldDataConfiguration?.maxQuantity ?? 0,
            onMin: handleMinQuantity,
            onMax: handleMaxQuantity,
            error: quantityRangeError,
            minTestId: 'components-multichoiceconfigurationnew-input-18',
            maxTestId: 'components-multichoiceconfigurationnew-input-19',
          },
        ].map((group) => (
          <div key={group.key} id={`${id}-${group.key}`}>
            <div className="tw-flex tw-items-center tw-gap-1">
              <Typography variant="sub-title-label" as="p" className="tw-text-ink-secondary">
                {group.title}
              </Typography>
              <InfoTooltip
                data-testid={`${id}-${group.key}-info`}
                placement="top"
                message={(
                  <span className="tw-block">
                    <span className="tw-block tw-font-semibold">{group.infoTitle}</span>
                    <span className="tw-block">{group.infoText}</span>
                  </span>
                )}
              />
            </div>
            <div className="tw-flex tw-gap-2 tw-mt-1">
              <TextField
                data-testid={group.minTestId}
                label={MIN}
                type="number"
                minValue={0}
                error={!!group.error}
                value={String(group.min)}
                onChange={(value) => group.onMin(Number(value))}
                onKeyDown={(e) => { if (e.key === '-') e.preventDefault(); }}
                placeholder={ENTER}
                className="tw-w-20"
              />
              <TextField
                data-testid={group.maxTestId}
                label={MAX}
                type="number"
                minValue={0}
                error={!!group.error}
                value={String(group.max)}
                onChange={(value) => group.onMax(Number(value))}
                onKeyDown={(e) => { if (e.key === '-') e.preventDefault(); }}
                placeholder={ENTER}
                className="tw-w-20"
              />
            </div>
            {group.error && (
              <Typography
                variant="caption-metadata"
                as="p"
                data-testid={`${id}-${group.key}-error`}
                className="tw-text-tone-danger-ink tw-mt-1 tw-max-w-[10.5rem] tw-break-words"
              >
                {group.error}
              </Typography>
            )}
          </div>
        ))}
      </div>

      {/* Was a hand-rolled `tw-fixed tw-inset-0` overlay — no focus trap, no Escape,
          no `aria-modal`, and its only way out was an X button. */}
      {showImage && (
        <Dialog
          isOpen
          onClose={() => setShowImage(false)}
          title={ITEM_IMAGE}
          size="lg"
          data-testid={`${id}-image-dialog`}
        >
          <div className="tw-w-[613px] tw-h-[613px] tw-bg-surface tw-rounded-srf tw-justify-center tw-items-center tw-flex tw-p-2">
            {imageUrl ? (
              <img src={imageUrl} alt="default-image" className="tw-max-w-full tw-max-h-full" />
            ) : (
              <Typography variant="body-primary" className="tw-text-ink-secondary">
                {NO_IMAGE_AVAILABLE}
              </Typography>
            )}
          </div>
        </Dialog>
      )}
    </Card>
  );
};

export default MultiChoiceConfigurations;
